import styled, { css, TColorProp } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/radius';

export const TagListInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};

  input[type='text'] {
    border: none;
    flex-grow: 1;
    min-width: 100px;
    font-size: 14px;
    outline: none;
  }
`;

export const TagsWrapper = styled.div<{
  $borderColor: TColorProp;
  $backgroundColor: TColorProp;
  $onHoverBackgroundColor: TColorProp;
  $onFocusBorderColor: TColorProp;
  $isFocused: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding-left: ${SPACING._10};
  padding-right: ${SPACING._10};
  min-height: ${SPACING._40};
  border-radius: ${RADIUS._8};
  border: ${({ theme, $borderColor }) =>
    `1px solid ${theme[$borderColor as string]}`};
  background-color: ${({ theme, $backgroundColor }) =>
    theme[$backgroundColor as string]};
  transition: all ease-in 0.2s;

  ${({ $isFocused, theme, $onFocusBorderColor }) =>
    $isFocused &&
    css`
      &:focus-within {
        border-color: ${theme[$onFocusBorderColor as string]};
      }
    `}

  input {
    transition: all ease-in 0.2s;
    background-color: ${({ theme, $backgroundColor }) =>
      theme[$backgroundColor as string]};
    color: ${({ theme }) => theme.neutral0};
  }

  &:hover {
    background-color: ${({ theme, $onHoverBackgroundColor }) =>
      theme[$onHoverBackgroundColor as string]};

    > input {
      background-color: ${({ theme, $onHoverBackgroundColor }) =>
        theme[$onHoverBackgroundColor as string]};
    }
  }
`;

export const Tags = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  cursor: pointer;

  span {
    margin-left: 4px;
    color: ${({ theme }) => theme.neutral1000};
  }

  #x-close {
    margin-top: 2px;
  }
`;
